<template>
    <div class="fault-chart" id="deliveryFaultPieChart"></div>
</template>

<script>
    import echarts from 'echarts'
    import deliveryFaultPie from './deliveryFaultPie.js'
    export default {
        name: '',
        components: {},
        mounted: function () {
            this.init()
        },
        data: function () {
            return {
                myChart: null,
                deliveryFaultPie: deliveryFaultPie,
            }
        },
        methods: {
            init(){
                this.myChart = echarts.init(document.getElementById('deliveryFaultPieChart'));
                this.myChart.setOption(this.deliveryFaultPie)
            }
        },
    }
</script>

<style lang="scss">
    .fault-chart{
        height: 100%;
    }
</style>
